import React, { useState } from "react";
import AssessmentList from "./listing";

import { useQuery } from "react-query";
import SideListView from "src/components/SideListView";
import { useDialog } from "src/contexts/dialog-context";
import { useStudent } from "src/contexts/student";
import api from "src/rest/api";
import { AssessmentClass } from "../fithub-shared/anthropometry/assessment";
import AssessmentContent from "./AssessmentContent";
import Table from "./comparision-table";
import { AssessmentContextProvider } from "./context/assessmentContext";
// import { Container } from './styles';

const Assessment: React.FC = () => {
  const [selected, setSelected] = useState("");

  const [comparisionList, setComparisionList] = useState<AssessmentClass[]>([]);

  function addComparision(id: string) {
    const find = data?.find((item) => item.id === id);

    if (find) {
      setComparisionList([...comparisionList, find]);
    }
  }

  function removeComparision(id: string) {
    setComparisionList((prev) => prev?.filter((item) => item.id !== id));
  }

  function onSetSelected(s: string) {
    setSelected("");
    setTimeout(() => {
      setSelected(s);
    }, 100);
  }

  const student = useStudent().student;

  const { data, refetch } = useQuery(["assessmentList", student?.id], () =>
    api
      .post<AssessmentClass[]>("/assessment/list", {
        user_id: student?.id,
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return [];
      }),
  );

  const dl = useDialog();

  function handleDelete() {
    dl.openDialog("Excluir", "Deseja excluir esta avaliação?", Delete);
  }

  function Delete() {
    api
      .post("/assessment/delete", {
        id: selected,
      })
      .then(() => {
        setSelected("");
        refetch();
      });
  }

  return (
    <AssessmentContextProvider>
      <div className="flex flex-1 flex-row overflow-hidden">
        <SideListView
          list={
            <AssessmentList
              onSetSelected={onSetSelected}
              handleDelete={handleDelete}
              selected={selected}
              Reload={refetch}
              list={data}
              addComparision={addComparision}
              removeComparision={removeComparision}
              comparisionList={comparisionList.map((e) => e.id)}
            />
          }
          content={
            comparisionList.length > 0 ? (
              <Table assessments={comparisionList} />
            ) : (
              selected && (
                <AssessmentContent
                  id={selected}
                  handleUnselect={() => onSetSelected("")}
                  handleReload={refetch}
                  handleDelete={handleDelete}
                />
              )
            )
          }
          view={selected ? "CONTENT" : "LIST"}
        />
      </div>
    </AssessmentContextProvider>
  );
};

export default Assessment;
